/********************* element-ui初始化 *********************/
import elementUI from 'element-ui';
// 全局设置
elementUI.Dialog.props.closeOnClickModal.default = false; // 点击model不关闭弹窗
elementUI.MessageBox.setDefaults({
    closeOnClickModal: false,
}); // 点击model不关闭弹窗
// 重写 Message
const $message = (option) => {
    elementUI.Message.closeAll();
    return elementUI.Message({
        ...option,
        offset: 70,
    });
};
['success', 'warning', 'info', 'error'].forEach((type) => {
    $message[type] = (option) => {
        if (typeof option === 'string') {
            option = {
                message: option,
                offset: 70,
            };
        }
        option.type = type;
        elementUI.Message.closeAll();
        return elementUI.Message(option);
    };
});
$message.close = elementUI.Message.close
$message.closeAll = elementUI.Message.closeAll
const element = {
    install: function (Vue) {
        Vue.use(elementUI, {
            size: 'small',
            zIndex: 3000,
        });
        Vue.prototype.$message = $message;
    },
};
export default element;
